// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1aLe5","left":"StickyBox_left__3qerE","right":"StickyBox_right__1mHY0"};